import { z } from 'zod';

const StringSchema = z.record(z.string());
const NumericStringSchema = z.record(z.string().regex(/^\d+$/, 'must contain only numeric characters'));

export const queryValidator = {
  stringValidate: <T extends object>(data: T) => {
    return StringSchema.parse(data) as T;
  },
  numericStringValidate: <T extends object>(data: T) => {
    return NumericStringSchema.parse(data) as T;
  },
};
